// src/redux/slices/managerProjectAssignCompleteSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config/api";
import axiosInstance from "../../../config/axiosConfig";

const BackendURL = config.backendUrl;

// Thunk to mark project assignment as complete
export const completeManagerProjectAssignment = createAsyncThunk(
  "managerProjectAssignComplete/complete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${BackendURL}/project-assigned/complete/${id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Something went wrong" }
      );
    }
  }
);

const managerProjectAssignCompleteSlice = createSlice({
  name: "managerProjectAssignComplete",
  initialState: {
    loading: false,
    success: false,
    error: null,
    data: null,
  },
  reducers: {
    resetManagerProjectAssignComplete(state) {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(completeManagerProjectAssignment.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(completeManagerProjectAssignment.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(completeManagerProjectAssignment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || { message: "Request failed" };
      });
  },
});

export const { resetManagerProjectAssignComplete } =
  managerProjectAssignCompleteSlice.actions;

export default managerProjectAssignCompleteSlice.reducer;
